import React, { forwardRef } from "react";
import { I18nContextProvider } from "../../i18n/i18n";
import { PaginationBase } from "./components/PaginationBase";
import { injectCatalog } from "./i18n/PaginationCatalog";
import { PaginationProps } from "./types";

export const Pagination = forwardRef<HTMLDivElement, PaginationProps>((props, ref) => {
    injectCatalog();
    const { locale, ...rest } = props;
    return (
        <I18nContextProvider locale={locale}>
            <PaginationBase {...rest} ref={ref} />
        </I18nContextProvider>
    );
});

Pagination.displayName = "Pagination";
